export default "__VITE_ASSET__b666a1a0__"